import * as React from "react";
import { connect } from "react-redux";

import { Button, Grid, Table, InputOnChangeData, Input } from "semantic-ui-react";

import { ApplicationState } from "../../../applicationState";
import { Dispatch } from "../../../store";
import { loadCustomerCategories } from "../actions";

import { CustomerCategoryListModel } from "../model";
import { customerCategoriesSelector } from "../selectors";

import { Link } from "redux-little-router";

interface DispatchProps {
    dispatchLoadCustomerCategories: () => Promise<void>;
}

interface StateProps {
    customerCategories: CustomerCategoryListModel[];
    path: string;
}

type AllProps = DispatchProps & StateProps;

const AllUnconnected: React.FunctionComponent<AllProps> = ({ dispatchLoadCustomerCategories, customerCategories, path }) => {
    const [name, setName] = React.useState("");

    const onFilterValueChange = React.useCallback((event: any, { value }: InputOnChangeData) => {
        setName(value);
    }, []);

    React.useEffect(() => {
        dispatchLoadCustomerCategories();
    }, [dispatchLoadCustomerCategories]);

    const filteredCategories = React.useMemo(
        () => customerCategories.filter(customerCategory =>
            customerCategory.name.toUpperCase().startsWith(name.toUpperCase())),
        [customerCategories, name]);

    return (
        <Grid container className="nomargintop">
            <Grid.Row>
                <Grid.Column width={14}>
                    <h1>Customer Categories</h1>
                </Grid.Column>
                <Grid.Column width={2} textAlign="right">
                    <Button icon="add" content="Create" as={Link} href={`${path}/create`} />
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column width={16}>
                    <Table>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>Name</Table.HeaderCell>
                            </Table.Row>
                            <Table.Row>
                                <Table.HeaderCell>
                                    <Input
                                        value={name}
                                        onChange={onFilterValueChange}
                                        icon="search"
                                        placeholder="Search..."
                                        size="mini"
                                    />
                                </Table.HeaderCell>

                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {filteredCategories
                                .map(customerCategory => (
                                    <Table.Row key={customerCategory.id}>
                                        <Table.Cell>
                                            <Link href={`${path}/${customerCategory.id}`}>
                                                {customerCategory.name}
                                            </Link>
                                        </Table.Cell>
                                    </Table.Row>
                                ))}
                        </Table.Body>
                    </Table>
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
};

function mapStateToProps(state: ApplicationState): StateProps {
    return {
        path: state.router.pathname,
        customerCategories: customerCategoriesSelector(state).sort((a, b) => a.name.localeCompare(b.name))
    };
}

function mapDispatchToProps(dispatch: Dispatch): DispatchProps {
    return {
        dispatchLoadCustomerCategories: () => dispatch(loadCustomerCategories())
    };
}

export const All =  connect(mapStateToProps, mapDispatchToProps)(AllUnconnected);
